import { Outlet } from 'react-router-dom';
import { ColourSchemeToggle } from './ColourSchemeToggle';

export function PublicLayout() {
  return (
    <>
      <div className="public-theme-bar">
        <ColourSchemeToggle />
      </div>
      <Outlet />
    </>
  );
}
